import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import pallet from 'constants/colors';

import steelblue from '../themes/white';
import Routes from '../routes';

const Root = props => (
  <Provider store={props.store}>
    <MuiThemeProvider muiTheme={getMuiTheme({ ...steelblue, palette: { ...steelblue.palette, ...pallet } })}>
      <Routes store={props.store} />
    </MuiThemeProvider>
  </Provider>
);

Root.propTypes = {
  store: PropTypes.object,
};

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root.prod.js